import React from "react";

export function BrandMark({ size = 56, className = "" }) {
  return (
    <div
      data-testid="brand-mark"
      className={`relative inline-flex items-center justify-center rounded-full bg-brand text-white shadow-md ${className}`}
      style={{ width: size, height: size }}
      aria-label="Sister Signal"
    >
      <Sparkle className="absolute -top-1 left-1/2 -translate-x-1/2 w-3 h-3 text-white/90" />
      <span className="font-serif italic font-semibold leading-none" style={{ fontSize: size * 0.32 }}>
        ss
      </span>
    </div>
  );
}

export function Wordmark({ className = "" }) {
  return (
    <div data-testid="brand-wordmark" className={`relative inline-flex flex-col items-start leading-[0.85] ${className}`}>
      <Sparkle className="absolute -top-3 left-2 w-3 h-3 text-brand" />
      <span className="font-serif italic font-semibold text-brand text-3xl">sister</span>
      <span className="font-serif italic font-semibold text-brand text-3xl">signal</span>
    </div>
  );
}

export function Sparkle({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 0c.4 5.2 2.6 7.4 7.8 7.8C14.6 8.2 12.4 10.4 12 16.6 11.6 10.4 9.4 8.2 4.2 7.8 9.4 7.4 11.6 5.2 12 0z" />
    </svg>
  );
}
